/**
 * Format click count for affiliate analytics display.
 * Abbreviates numbers >= 1000 with 'K' suffix.
 *
 * @example
 * formatAffiliateClicks(42) // "42 clicks"
 * formatAffiliateClicks(1500) // "1.5K clicks"
 * formatAffiliateClicks(10000) // "10.0K clicks"
 */
export function formatAffiliateClicks(clickCount: number): string {
  if (clickCount >= 1000) {
    return `${(clickCount / 1000).toFixed(1)}K clicks`;
  }
  return `${clickCount} clicks`;
}

/**
 * Format earnings amount for affiliate analytics display.
 * Abbreviates numbers >= 1000 with 'K' suffix.
 *
 * @example
 * formatAffiliateEarnings(42.50) // "$42.50"
 * formatAffiliateEarnings(1500) // "$1.5K"
 * formatAffiliateEarnings(10000) // "$10.0K"
 */
export function formatAffiliateEarnings(amount: number): string {
  if (amount >= 1000) {
    return `$${(amount / 1000).toFixed(1)}K`;
  }
  return `$${amount.toFixed(2)}`;
}
